import React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

type Props = React.SVGProps<SVGSVGElement> & {
  disabled: boolean,
  active: boolean,
}
const AttachmentActiveIcon = ({ disabled, active, ...props }: Props) => {


  let currentIcon: JSX.Element | null;
  if (disabled) {
    currentIcon = null;
  } else if (active) {
    currentIcon = (
      <path
        d="M18.5303 5.99995L20.4303 8.04995L24.9403 3.94995"
        strokeLinecap="round" />
    );
  } else {
    currentIcon = (
      <React.Fragment>
        <path
          d="M24.1337 6H19.0972"
          strokeLinecap="round"
          strokeLinejoin="round" />
        <path
          d="M21.6255 8.51001V3.51001"
          strokeLinecap="round"
          strokeLinejoin="round" />
      </React.Fragment>
    );
  }

  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="currentColor"
      data-qa-ref={active ? 'attachment-active' : 'attachment-inactive'}
      className={classnames(styles.icons, props.className)}
    >
      <path
        d="M20.9398 11.45V22.15C20.8208 24.7946 18.6421 26.8775 15.9948 26.8775C13.3475 26.8775 11.1688 24.7946 11.0498 22.15V11.45C11.1462 9.70062 12.5928 8.33154 14.3448 8.33154C16.0968 8.33154 17.5434 9.70062 17.6398 11.45V22.15C17.6398 23.0612 16.9011 23.8 15.9898 23.8C15.0785 23.8 14.3398 23.0612 14.3398 22.15V12.28"
        strokeLinecap="round"
        strokeLinejoin="round" />
      {currentIcon}
    </svg>
  );
};
export default React.memo(AttachmentActiveIcon);
